import { Popup } from "@/components/popups/Popup";
import SuccessCircleIcon from "./images/icons/success-circle.svg?react";
import { Button } from "@/components/buttons/Button";
import { onCloseAddToNicheSuccessPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import "./AddToNicheSuccessPopup.scss";

export const AddToNicheSuccessPopup = () => {

  return (
    <Popup
      isOpen={true}
      popupClass="AddToNicheSuccessPopup"
    >
      <div className="AddToNicheSuccessPopup-Content">
        <div className="SuccessIcon">
          <SuccessCircleIcon />
        </div>
        <h2>Success!</h2>
        <p>This content has now been added to your chosen Niche(s). Thanks for helping RedGIFs users find content they love!</p>
        <Button size="l" onClick={() => onCloseAddToNicheSuccessPopup()} variant="primary">Continue</Button>
      </div>
    </Popup>
  );
};

